import superjson from "superjson";

export const transformer = superjson;

export function getBaseUrl() {
  const url = process.env.EXPO_PUBLIC_API_URL as string;
  return url ? url : "";
}